import axios from 'axios';
import config from '../config';

const userService = {
  getUsers: async (token, page = 1, perPage = 30) => {
    try {
      const response = await axios.get(
        `${config.API_BASE_URL_V1}agency/user/list?page=${page}&per_page=${perPage}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch users');
    }
  },

  deleteUser: async (token, agencyId, userId) => {
    try {
      const response = await axios.delete(
        `${config.API_BASE_URL_V1}agency/user/${userId}/delete`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete user');
    }
  }
};

export default userService; 